<template lang="pug">
  info-card(title="Vídeos mais reproduzidos" icon="fas fa-star")
    .card-body(slot="card-body")
      div(v-if="mostViewedItems.length > 0")
        .columns.my-2.py-2.align-center(v-for="item in mostViewedItems")
          .column.col-2.column-cover
            img.img-cover.img-responsive(:src="item.cover || require('@/assets/video-thumbnail-default.png')")
          .column
            .text-bold {{ item.title }}
            .text Tempo assistido: #[b ≅ {{ item.secondsWatched | secondsToMinutes }} {{ item.secondsWatched > 60 ? 'minutos' : 'minuto' }}]
      .empty(v-else)
        .empty-icon
          i.fas.fa-3x.fa-eye-slash
        p.empty-title.h5 Nenhuma exibição
        p.empty-subtitle Seus vídeos não foram exibidos neste período

</template>

<script>
export default {
  props: {
    mostViewedItems: { type: Array, required: true },
  },
}
</script>

<style lang="stylus" scoped>
.columns
  border-bottom 1px solid #eee
  &:last-child
    border-bottom none
  .column-cover
    min-width 70px
.img-cover
  border-radius 5px
</style>
